import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert, InputAdornment, IconButton, CircularProgress } from '@mui/material';
import { Visibility, VisibilityOff, School as SchoolIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';

export default function Login() {
  const { login } = useAuth();
  const { slug } = useParams(); // present when accessed via /school/:slug/login
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const result = await login(form.username, form.password, slug || null);
    setLoading(false);
    if (result.success) {
      const dest = result.school_slug
        ? `/school/${result.school_slug}/dashboard`
        : '/dashboard';
      navigate(dest, { replace: true });
    } else setError(result.message || 'Login failed');
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 50%, #01579b 100%)' }}>
      <Card sx={{ width: '100%', maxWidth: 420, mx: 2, borderRadius: 3, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            {settings.logo
              ? <Box component="img" src={`${process.env.REACT_APP_API_URL?.replace('/api','')}/uploads/${settings.logo}`}
                  alt="logo" sx={{ width: 70, height: 70, borderRadius: 2, objectFit: 'cover', mb: 1 }} />
              : <SchoolIcon sx={{ fontSize: 60, color: 'primary.main', mb: 1 }} />
            }
            <Typography variant="h5" fontWeight={700}>{settings.school_name || 'School Management'}</Typography>
            <Typography variant="body2" color="text.secondary">Sign in to continue</Typography>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Email or Username" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required autoFocus />
            <TextField
              label="Password" type={showPass ? 'text' : 'password'}
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required
              InputProps={{ endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPass(!showPass)} edge="end" size="small">
                    {showPass ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}}
            />
            <Button type="submit" variant="contained" size="large" disabled={loading}
              sx={{ mt: 1, py: 1.5, fontWeight: 700, fontSize: 16 }}>
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
            </Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 3 }}>
            Default: admin / Admin@1234
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
